quoteModule.factory("CustomerInfo", function() {

    var BuyerInfo = function() {
        this.firstName = "";
        this.middleName = "";
        this.lastName = "";
        this.email = "";
    };

    var CoBuyerInfo = function(){
        this.firstName = "";
        this.middleName = "";
        this.lastName = "";
        this.email = "";
    };

    var BusinessInfo = function() {
        this.businessName = "";
        this.driverFirstName = "";
        this.driverLastName = "";
    };

    var CustomerInfo = function(){

        this.BuyerInfo = new BuyerInfo();
        this.CoBuyerInfo = new CoBuyerInfo();
        this.BusinessInfo = new BusinessInfo();
        this.customerNumber = "";
        this.address1 = "";
        this.address2 = "";
        this.city = "";
        this.phone1 = "";
        this.phone2 = "";
        this.state = "";
        this.zip = "";
    }

    //validation for saving the quote
    CustomerInfo.prototype.dataReadyToSaveQuote = function() {
        var dataReady = true;

        // this is where we'd check for first name/last name or business name info, if it was required

        return dataReady;
    };

    CustomerInfo.prototype.consumeFromRateQuoteRetrieve = function(custRateInfo){
        if (custRateInfo) {
            this.BuyerInfo.firstName = custRateInfo.BuyerFirstName;
            this.BuyerInfo.lastName = custRateInfo.BuyerLastName;
            this.BuyerInfo.middleName = custRateInfo.BuyerMiddleName;
            this.BuyerInfo.email = custRateInfo.BuyerEmail;
            this.CoBuyerInfo.firstName = custRateInfo.CoBuyerFirstName;
            this.CoBuyerInfo.lastName = custRateInfo.CoBuyerLastName;
            this.CoBuyerInfo.middleName = custRateInfo.CoBuyerMiddleName;
            this.CoBuyerInfo.email = custRateInfo.CoBuyerEmail;
            this.address1 = custRateInfo.CustomerAddressLine1;
            this.address2 = custRateInfo.CustomerAddressLine2;
            this.city = custRateInfo.City;
            this.state = custRateInfo.State;
            this.zip = custRateInfo.Zip;
            this.phone1 = custRateInfo.CustomerPhone1;
            this.phone2 = custRateInfo.CustomerPhone2;
        }
    }

    return CustomerInfo;
});

